import { type ExportListSuccess, type ExportData, type ExportListInput } from '@terros/common'
import { type TinyQueryOptions, useTantalimQuery } from '../query'
import { exportsKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useExports(opts?: TinyQueryOptions): GetHookResponse<ExportData[]> {
  const input: ExportListInput = {}
  return useTantalimQuery<ExportListInput, ExportListSuccess, ExportData[]>({
    url: '/export/list',
    queryKey: exportsKey(input),
    input,
    convertResponse: (data) => {
      return data.exports
    },
    options: opts,
  })
}
